export class SessionContext {

    constructor(
        public usingInitial: boolean,
        public channelId: number,
        public nextSequenceNumber: number
    ) {}

    static allMessages(): SessionContext {
        return new SessionContext(true, 0, 1);
    }

    static newMessages(): SessionContext {
        return new SessionContext(true, 0, 0);
    }
}
